import { afterEach, beforeEach, describe, expect, it, vi } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../shared/cardConfig/constants';
import { PAGE_ROUTES } from '../../../../../utils/constants';
import * as hooksLib from '../../../../../utils/hooksLib';
import { type Card, getShipToCardsForReviewPage, type Page,templateMap } from './create';

describe('Template Configuration (Customer Setup)', () => {
  describe('getShipToCardsForReviewPage', () => {
    const mockSubtitle = 'Mock Subtitle';

    beforeEach(() => {
      vi.spyOn(hooksLib, 'getShipToSubtitle').mockReturnValue(mockSubtitle);
    });

    afterEach(() => {
      vi.restoreAllMocks();
    });

    it('returns correct structure for single shipTo', () => {
      const store = {
        customer: {
          shipTo: [{ address: { city: 'Test City' } }]
        }
      };

      const result = getShipToCardsForReviewPage({ store });

      expect(result).toHaveLength(1);

      expect(result[0]).toMatchObject({
        title: 'tabTitles.ship to',
        count: 1,
        subtitle: mockSubtitle
      });

      expect(Array.isArray(result[0].cards)).toBe(true);
    });

    it('does not remove any cards for second shipTo (no invoiceDelivery present)', () => {
      const store = {
        customer: {
          shipTo: [{ address: {} }, { address: {} }]
        }
      };

      const result = getShipToCardsForReviewPage({ store });

      expect(result).toHaveLength(2);

      const firstCards = result[0].cards;
      const secondCards = result[1].cards;

      expect(firstCards.length).toBe(secondCards.length);
    });
  });

  describe('templateMap structure', () => {
    it('contains customer_set_up template', () => {
      expect(templateMap.customer_set_up).toBeDefined();
      expect(Array.isArray(templateMap.customer_set_up.pages)).toBe(true);
    });

    it('customer_set_up contains expected routes', () => {
      const pages = templateMap.customer_set_up.pages;
      const routes = pages.map(page => page.route);

      expect(routes).toContain(PAGE_ROUTES.company);
      expect(routes).toContain(PAGE_ROUTES.shipTo);
      expect(routes).toContain(PAGE_ROUTES.financial);
      expect(routes).toContain(PAGE_ROUTES.review);
    });

    it('financial page has validateFinancials flag', () => {
      const financialPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.financial
      ) as Page;

      expect(financialPage.validateFinancials).toBe(true);
      expect(Array.isArray(financialPage.cards)).toBe(true);
    });

    it('billTo card is optional in company page', () => {
      const companyPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.company
      ) as Page;

      const billToCard = companyPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.billTo
      ) as Card;

      expect(billToCard).toBeDefined();
      expect(billToCard.isCardOptional).toBe(true);
    });

    it('shipTo address card hides same as billTo', () => {
      const shipToPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.shipTo
      ) as Page;

      const addressCard = shipToPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.address
      ) as Card;

      expect(addressCard.hideSameAsBillTo).toBe(true);
    });

    it('payer card hides same as billTo', () => {
      const financialPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.financial
      ) as Page;

      const payerCard = financialPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.payer
      ) as Card;

      expect(payerCard.hideSameAsBillTo).toBe(true);
    });

    it('review page contains correct accordions', () => {
      const reviewPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.review
      ) as Page;

      expect(Array.isArray(reviewPage.accordions)).toBe(true);
      expect(reviewPage.accordions!.length).toBe(3);

      expect((reviewPage.accordions![0] as { title: string }).title).toBe('tabTitles.company');
      expect((reviewPage.accordions![2] as { title: string }).title).toBe('tabTitles.financial');
    });

    it('contains other templates (bill_to, payer, ship_to, sold_to)', () => {
      expect(templateMap.bill_to).toBeDefined();
      expect(templateMap.payer).toBeDefined();
      expect(templateMap.ship_to).toBeDefined();
      expect(templateMap.sold_to).toBeDefined();
    });
  });
});
